import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DsIconComponent, DsIconName } from './icon.component';

@Component({
  selector: 'ds-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-table' },
  template: `<div class="ds-table__scroll" tabindex="0" [attr.aria-label]="label()">
    <table>
      <ng-content />
    </table>
  </div>`,
})
export class DsTableComponent {
  readonly label = input('Data table');
}

@Component({
  selector: 'ds-spinner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-spinner', role: 'status' },
  template: `<span aria-hidden="true"></span><span class="ds-visually-hidden">{{ label() }}</span>`,
})
export class DsSpinnerComponent {
  readonly label = input('Loading');
}

@Component({
  selector: 'ds-state',
  imports: [DsIconComponent, DsSpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-state', '[attr.role]': "kind() === 'error' ? 'alert' : 'status'" },
  template: `@if (kind() === 'loading') {
      <ds-spinner [label]="title()" />
    } @else {
      <ds-icon [name]="icon()" />
    }
    <h2>{{ title() }}</h2>
    <p>{{ message() }}</p>
    <div class="ds-state__actions"><ng-content /></div>`,
})
export class DsStateComponent {
  readonly kind = input<'empty' | 'error' | 'loading'>('empty');
  readonly title = input.required<string>();
  readonly message = input('');
  protected icon(): DsIconName {
    return this.kind() === 'error' ? 'warning' : 'info';
  }
}

@Component({
  selector: 'ds-skeleton',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-skeleton', '[attr.aria-hidden]': 'true' },
  template: '',
})
export class DsSkeletonComponent {}
